//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HeaderButton from '~sdp-components/Header/HeaderButton'
import GlossaryIcon from '~sdp-components/Icons/GlossaryIcon'

export default {
  components: {
    HeaderButton,
    GlossaryIcon,
  },
}
